import http from '@/config/http';

export default {
    namespaced: true,

    state: {
        saving: false,
        formdata: {},
    },
    
    getters: {},
    
    mutations: {
        saving: (state, val) => state.saving = val,
        resetform: (state, val) => state.formdata = {},
        
        to: (state, val) => state.formdata.to = val,
        cc: (state, val) => state.formdata.cc = val,
        closed: (state, val) => state.formdata.closed = val,
        hidden: (state, val) => state.formdata.hidden = val,
        ndas: (state, val) => state.formdata.ndas = val,
    },
    
    actions: {
        async saveEvent({state}, eventid) {
            try {
                let data = { id: eventid, ...state.formdata };
                const resp = http.post(`event/event-c.php5?fn=update_event&pmode=${process.env.VUE_APP_PMODE}`, data);
                console.log(resp);
            }
            catch (e) {
                console.log(e);
            }
        },
    },
}
